import { render, staticRenderFns } from "./politica-privacidad.vue?vue&type=template&id=692da9a8&scoped=true"
import script from "./politica-privacidad.vue?vue&type=script&lang=js"
export * from "./politica-privacidad.vue?vue&type=script&lang=js"
import style0 from "./politica-privacidad.vue?vue&type=style&index=0&id=692da9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692da9a8",
  null
  
)

export default component.exports